module.exports = __webpack_public_path__ + "static/media/PaketB.b2b075a6.jpeg";